import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { api } from '../lib/api.ts';
import { Aviso, Boton, Campo } from '../componentes/ui.tsx';

export function PaginaRecuperar() {
  const { t } = useTranslation();
  const navegar = useNavigate();
  const [username, setUsername] = useState('');
  const [enviado, setEnviado] = useState(false);

  async function enviar(evento: React.FormEvent) {
    evento.preventDefault();
    // Respuesta idéntica exista o no la cuenta: el backend no filtra quién tiene usuario.
    await api('/auth/forgot-password', {
      metodo: 'POST',
      cuerpo: { username: username.trim() },
    }).catch(() => undefined);
    setEnviado(true);
  }

  return (
    <main className="flex min-h-full items-center justify-center py-6">
      <form
        onSubmit={enviar}
        className="tarjeta w-full max-w-md space-y-4 p-8"
      >
        <h1 className="text-[30px] font-light">
          {t('recuperar.titulo')}
        </h1>
        <p className="text-sm text-suave">{t('recuperar.explicacion')}</p>

        <Campo
          etiqueta={t('login.usuario')}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />

        {enviado ? <Aviso tono="ok">{t('recuperar.enviado')}</Aviso> : null}

        <Boton type="submit" className="w-full" disabled={enviado}>
          {t('recuperar.enviar')}
        </Boton>
        <Boton
          type="button"
          variante="texto"
          className="w-full"
          onClick={() => void navegar({ to: '/login' })}
        >
          {t('recuperar.volver')}
        </Boton>
      </form>
    </main>
  );
}
